import Vue from "vue";
import App from "./App.vue";

const elements = document.querySelectorAll(".googleMaps");

if (elements) {
  elements.forEach(element => {
    Vue.config.productionTip = false;

    new Vue({
      render: createElement => {
        const context = {
          props: { ...element.dataset }
        };
        return createElement(App, context);
      }
    }).$mount(`#${element.id}`);
  });
}
